var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"shopping-cart-item-wrapper\"> <div class=\"shopping-cart-passenger\" id=\"number-of-passengers\"> <i class=\"fa fa-user-plus shopping-cart-icon\" aria-hidden=\"true\"></i> <winres-departures-search mode=\"horizontal\" template-url=\"custom/template/numberOfPeopleSearch.html\" on-update=\"this.searchCriteria = searchCriteria\" passenger-counts=\"popup\" internet-classification-title-2=\"randomi title\" use-current-destination=\"true\"> </winres-departures-search> <winres-departures-list mode=\"table\" search-criteria=\"searchCriteria\" with-reserve-link=\"false\" reservation-link-template=\"{{$ctrl.reservationLinkTemplate}}\" template-url=\"custom/supergolf/numberOfPeopleResults.html\"> </winres-departures-list> </div> </div>";
var id1="winresReservationNoOfPeople.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationNoOfPeople/winresReservationNoOfPeople.html
// module id = 428
// module chunks = 2